import { FC } from 'react';

import CashoutLayout from 'cashout/components/layouts/cashout-layout';

import RoutesWithNotFound from 'common/config/routes/routesWithNotFound.util';

interface Props {
  children: JSX.Element[] | JSX.Element;
}

const CashoutRouting: FC<Props> = ({ children }) => {
  return (
    <CashoutLayout>
      <RoutesWithNotFound>{children}</RoutesWithNotFound>
    </CashoutLayout>
  );
};
export default CashoutRouting;
